import SectionHeading from "./SectionHeading";
import { themes } from "@/mocks/doujinshi";

export default function Themes() {
  return (
    <section id="themes" className="bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="主题浏览"
          title="按兴趣题材，找到你的同人志"
          desc="校园、奇幻、治愈、战斗、恋爱、悬疑……用题材快速筛出最对你胃口的那一本。"
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {themes.map((t) => (
            <a
              key={t.id}
              href="#trending"
              className="group relative overflow-hidden rounded-lg"
            >
              <div className="h-40 w-full overflow-hidden md:h-44">
                <img
                  src={t.cover}
                  alt={`${t.name} 题材的同人志合集`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/25 to-transparent"></div>
              <div className="absolute bottom-0 left-0 flex w-full items-end justify-between p-4">
                <div>
                  <h3 className="font-heading text-lg font-bold text-background-50">{t.name}</h3>
                  <p className="mt-0.5 text-xs text-background-100/80">{t.count} 部打包作品</p>
                </div>
                <span className="grid h-9 w-9 items-center justify-center rounded-full bg-background-50/90 text-background-50 opacity-0 transition-opacity group-hover:opacity-100">
                  <i className="ri-arrow-right-line text-foreground-950"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}